module.exports = __webpack_public_path__ + "img/orthopaedics.bd4c48c1.png";